var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 14.4C9.69748 14.4 11.3253 13.7257 12.5256 12.5255C13.7258 11.3253 14.4001 9.69739 14.4001 8.00001C14.4001 6.30262 13.7258 4.67476 12.5256 3.47452C11.3253 2.27429 9.69748 1.60001 8.0001 1.60001C6.30271 1.60001 4.67485 2.27429 3.47461 3.47452C2.27438 4.67476 1.6001 6.30262 1.6001 8.00001C1.6001 9.69739 2.27438 11.3253 3.47461 12.5255C4.67485 13.7257 6.30271 14.4 8.0001 14.4ZM8.8001 4.80001C8.8001 4.58783 8.71581 4.38435 8.56578 4.23432C8.41575 4.08429 8.21227 4.00001 8.0001 4.00001C7.78792 4.00001 7.58444 4.08429 7.43441 4.23432C7.28438 4.38435 7.2001 4.58783 7.2001 4.80001V8.00001C7.20014 8.21216 7.28446 8.41561 7.4345 8.56561L9.6969 10.8288C9.77123 10.9031 9.85947 10.9621 9.95658 11.0023C10.0537 11.0425 10.1578 11.0633 10.2629 11.0633C10.368 11.0633 10.4721 11.0425 10.5692 11.0023C10.6663 10.9621 10.7546 10.9031 10.8289 10.8288C10.9032 10.7545 10.9622 10.6662 11.0024 10.5691C11.0426 10.472 11.0633 10.3679 11.0633 10.2628C11.0633 10.1577 11.0426 10.0536 11.0024 9.95649C10.9622 9.85937 10.9032 9.77113 10.8289 9.69681L8.8001 7.66881V4.80001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.0514738af23ca92379e8b9f8b416904a.svg";
export { ForwardRef as ReactComponent };